<div class="row">
    <div [ngClass]="{'col-10 pr-0': showStages, 'col-12': !showStages}">
        <div class="row mt-2 mr-1">
            <div class="col-sm-6">
                <button *ngIf="!isLocked" kendoButton [primary]="true" class="ml-3" (click)="updateItems()"
                    type="button" [disabled]="selectedItems.length === 0 || discarding"
                    title="{{ 'UPDATE-DISCARD-TOOLTIP' | translate }}">{{ 'UPDATE-DISCARD' | translate }}<i
                        class="far fa-check"></i>
                </button>
            </div>
            <div class="col-sm-6">
                <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                    <app-advanced-mode id="integrityItemShowStageSwitch" [storageKey]="'integrity-items-show-stage'"
                        [titleKey]="'SHOW-STAGES'" (collapsibleToggle)="showStages=$event" class="mr-4">
                    </app-advanced-mode>
                    <app-advanced-mode id="integrityItemShowStageSwitch" [storageKey]="'integrity-items-list'"
                        (collapsibleToggle)="enableAdvanced=$event">
                    </app-advanced-mode>
                </div>
            </div>
        </div>
        <div class="m-3 pb-2">
            <kendo-grid [data]="gridView" [loading]="loading" [navigable]="true"
                [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                [pageSize]="state.take" [skip]="state.skip" [sortable]="true" [sort]="state.sort"
                [filterable]="enableAdvanced" [filter]="state.filter"
                [selectable]="{ mode: (isLocked ? 'single' : 'multiple') }" [columnMenu]="enableAdvanced"
                [resizable]="true" [reorderable]="enableAdvanced" [selectedKeys]="selectedItems"
                (dataStateChange)="dataStateChange($event)" [kendoGridSelectBy]="'id'"
                (columnReorder)="onReorder($event)" (columnResize)="onResize($event)"
                (columnVisibilityChange)="onVisibilityChange($event)" (edit)="editHandler($event)"
                (cancel)="cancelHandler($event)" (save)="saveHandler($event)"
                (selectedKeysChange)="onSelectedKeysChange($event)">
                <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                    <button kendoButton (click)="resetGridColumns()" class="float-right">
                        {{'RESET-GRID-COLUMNS' | translate }}
                    </button>
                </ng-template>
                <kendo-grid-checkbox-column *ngIf="!isLocked" [columnMenu]="false" [width]="45" class="text-center"
                    headerClass="text-center" [reorderable]="false">
                </kendo-grid-checkbox-column>
                <!--Based grid columns-->
                <kendo-grid-column *ngFor="let col of getColumnsForGroup(0)" [field]="col.field" [title]="col.title"
                    [width]="col.width" [filter]="col.filter" [editor]="col.editor" [format]="col.format"
                    [filterable]="col.filterable !== undefined ? col.filterable : true"
                    [hidden]="col.hidden !== undefined ? col.hidden : false"
                    [editable]="col.field === 'id' ? false : true"
                    [class]="col.filter === 'boolean' ? 'text-center' : ''">
                    <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.filter === 'boolean'">
                        <i *ngIf="dataItem[col.field] && col.field === 'valid'"
                            class="fas fa-check-circle valid-status">
                        </i>
                        <i *ngIf="!dataItem[col.field] && col.field === 'valid' && integrityBatch.integrityStage !== 'IN_REVIEW'"
                            class=" fas fa-times-circle invalid-status">
                        </i>
                        <i *ngIf="!dataItem[col.field] && col.field === 'valid' && integrityBatch.integrityStage === 'IN_REVIEW'"
                            class=" fas fa-minus-circle unset-status">
                        </i>
                        <i *ngIf="dataItem[col.field] && (col.field === 'discarded' || col.field === 'requireUpdate')"
                            class="fas fa-check">
                        </i>
                    </ng-template>
                    <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.field === 'discarded'">
                        <form [formGroup]="formGroup">
                            <input type="checkbox" formControlName="discarded" kendoCheckBox />
                        </form>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'memberName'">
                        <a [routerLink]="['/patient', dataItem.memberId]" [queryParams]="{breadcrumb: breadcrumb}"
                            class="pointer emphasizedLabel">
                            {{ dataItem.memberName }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <!--New Address columns-->
                <kendo-grid-column-group title="{{'INTEGRITY-NEW-ADDRESS' | translate}}">
                    <kendo-grid-column *ngFor="let col of getColumnsForGroup(1)" [field]="col.field" [title]="col.title"
                        [width]="col.width" [filter]="col.filter" [editor]="col.editor" [format]="col.format"
                        [filterable]="col.filterable !== undefined ? col.filterable : true"
                        [hidden]="col.hidden !== undefined ? col.hidden : false"
                        [editable]="col.field === 'id' ? false : true"
                        [class]="col.filter === 'boolean' ? 'text-center' : ''">
                    </kendo-grid-column>
                </kendo-grid-column-group>
                <kendo-grid-command-column *ngIf="!isLocked" [width]="80" title="{{ 'ACTIONS' | translate }}"
                    class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <ng-container *ngIf="!dataItem.editing">
                            <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                                (click)="itemEditButton.click.emit($event); dataItem.editing = true;"></i>
                            <button kendoGridEditCommand #itemEditButton class="d-none"></button>
                        </ng-container>
                        <ng-container *ngIf="dataItem.editing">
                            <ng-container *ngIf="formGroup.valid">
                                <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                                    (click)="itemSaveButton.click.emit($event); dataItem.editing = false;">
                                </i>
                                &nbsp;
                            </ng-container>
                            <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                                (click)="itemCancelButton.click.emit($event); dataItem.editing = false;"></i>
                            <button kendoGridSaveCommand #itemSaveButton class="d-none"></button>
                            <button kendoGridCancelCommand #itemCancelButton class="d-none"></button>
                        </ng-container>
                    </ng-template>
                </kendo-grid-command-column>
                <ng-template kendoGridDetailTemplate let-dataItem width="200">
                    <section>
                        <div class="k-text-uppercase dark">{{'INTEGRITY-CURRENT-ADDRESS'|translate}}</div>
                        <div class="row" *ngIf="dataItem.currentStreet">
                            <div class="col-3 text-right current-address-label">{{'SHORT-ADDRESS-LINE-1'|translate}}:
                            </div>
                            <div class="col-9">{{ dataItem.currentStreet }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentStreetAdditional">
                            <div class="col-3 text-right current-address-label">{{'SHORT-ADDRESS-LINE-2'|translate}}:
                            </div>
                            <div class="col-9">{{ dataItem.currentStreetAdditional }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentCity">
                            <div class="col-3 text-right current-address-label">{{'CITY'|translate}}:</div>
                            <div class="col-9">{{ dataItem.currentCity }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentCounty">
                            <div class="col-3 text-right current-address-label">{{'COUNTY'|translate}}:</div>
                            <div class="col-9">{{ dataItem.currentCounty }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentState">
                            <div class="col-3 text-right current-address-label">{{'STATE'|translate}}:</div>
                            <div class="col-9">{{ dataItem.currentState }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentPostalCode">
                            <div class="col-3 text-right current-address-label">{{'POSTAL-CODE'|translate}}:</div>
                            <div class="col-9">{{ dataItem.currentPostalCode }}</div>
                        </div>
                        <div class="row" *ngIf="dataItem.currentCountry">
                            <div class="col-3 text-right current-address-label">{{'COUNTRY'|translate}}:</div>
                            <div class="col-9">{{ dataItem.currentCountry }}</div>
                        </div>
                    </section>
                </ng-template>
            </kendo-grid>
        </div>
    </div>
    <div class="col-2 pl-0" style="min-width: 260px;" *ngIf="showStages">
        <kendo-stepper #stepper [steps]="integrityStages" [stepType]="'full'" [(currentStep)]="currentStage"
            [linear]="false" [successSVGIcon]="checkCircleIcon" [errorSVGIcon]="closeOutlineIcon" [style.width.px]="260"
            [orientation]="'vertical'" class="mt-2">
        </kendo-stepper>
    </div>
</div>